import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Goals = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} isMargin={false} className="conveter-goals">
                <div className="conveter-goals__wrapper">
                    <div className="conveter-goals__info">
                        <CommonTitle>Цели</CommonTitle>
                        <CommonSmallText>
                            Перед нами стоит глобальная цель&nbsp;&mdash; мы&nbsp;хотим стать
                            лидирующей платформой по&nbsp;конвертации файлов на&nbsp;мировом уровне.
                            Уже сейчас мы&nbsp;занимаем 5-е место. Путь, который остальные
                            продуктовые команды проходили 7-8&nbsp;лет, мы&nbsp;освоили
                            за&nbsp;2&nbsp;года. Динамика и&nbsp;драйв&nbsp;&mdash; это важные
                            свойства команды, которые позволяют нам достигать поставленных целей
                            в&nbsp;разы быстрее.
                        </CommonSmallText>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Goals;
